export default __webpack_public_path__ + "static/8-e5f293ceb7f86f85d99a9ea3d1b8a85d.jpg";